import React from 'react';

const ReferralRewardFormModal = React.lazy(() => import('../components/FormModal'));
const referralRewardModalRegistry = {
    core_referralRewardId: ReferralRewardFormModal
};
export default referralRewardModalRegistry;
